<template>
		<el-drawer custom-class="knowledge" title="知识库" size="1200px" :visible.sync="visible" :before-close="onClose">
      <div class="box">
        <el-input placeholder="疾病、用药、诊断…" @keyup.enter.native="onSearch" v-model="filter.content" clearable @clear="onSearch"></el-input>
        <el-button icon="el-icon-search" @click="onSearch">搜索</el-button>
      </div>
      <!-- <div class="hot-key">
        热闹搜索词： 
        <el-button type="text">糖尿病</el-button>
        <el-button type="text">高血压</el-button>
        <el-button type="text">高血脂</el-button>
        <el-button type="text">疾病管理</el-button>
      </div> -->
      <el-row class="km" :gutter="20">
        <el-col style="height:100%; overflow: auto;" :span="7">
          <AutoMenu :menu="menu" @select="onMenuSelect"></AutoMenu>
        </el-col>

        <el-col :span="17">
          <div class="infinite-list" v-infinite-scroll="onLoadMore" infinite-scroll-disabled="disabled" style="overflow:auto">
            <div v-for="(item, key) in items" :key="key" class="key-item" :class="{hide: descActive !== item.id}">
              <div class="title" v-html="item.title"></div>
              <div class="desc" v-html="item.context"></div>
              <div class="cate">分类：{{ item.category1 }} > {{ item.category2 }} > {{ item.category3 }}</div>
              <!-- <div class="source">来源：{{ item.source }}</div> -->
              <div class="extra">
                <div class="date">更新时间：{{ dateFormat(item.updateTime) }}</div>
                <div class="link">
                  <el-link type="primary" class="collapse" :underline="false" @click="onToggle(item.id)">查看详情<i class="el-icon-arrow-right"></i></el-link>
                  <el-link type="primary" class="expand" :underline="false" @click="onToggle">收起详情<i class="el-icon-arrow-up"></i></el-link>
                </div>
              </div>
            </div>
            <div v-if="loading" style="color: #bbb; text-align: center;">加载中...</div>
            <div v-if="noMore" style="color: #bbb; text-align: center;">没有更多数据</div>
          </div>

          <!-- <div class="key-item hide">
            <div class="title">糖尿病营养治疗的目的</div>
            <div class="desc">医学营养治疗是糖尿病的基础治疗手段，包括对患者进行个体化营养评估、营养诊断、制定相应营养干预计划，并在一定时期内实施及监测。此治疗通过调整饮食总能量、饮食结构及餐次分配比例，有利于血糖控制，有助于维持理想体重并预防营养不良发生，是糖尿病及其并发症的预防、治疗、自我管理以及教育的重要组成部分。</div>
            <div class="cate">分类：疾病>慢病>糖尿病</div>
            <div class="source">来源：实用内科学【第十五版】</div>
            <div class="date">
              <div>更新时间：2022/01/17 17:37:24</div>
              <div>
                <el-link type="primary" class="collapse">查看详情<i class="el-icon-arrow-right"></i></el-link>
                <el-link type="primary" class="expand">收起详情<i class="el-icon-arrow-up"></i></el-link>
              </div>
            </div>
          </div> -->

        </el-col>
      </el-row>
		</el-drawer>

</template>

<script>
import dayjs from 'dayjs';
import api from '../../service/api';

import infiniteScroll from '@/directive/infinite-scroll';
import AutoMenu from '@/components/AutoMenu';

export default {
  name: 'Knowledge',
  directives: {infiniteScroll },
  components: {AutoMenu},
  props: {
    msg: String,
    visible: Boolean,
  },
  computed: {
    noMore () {
      return (this.filter.pageNumber * this.filter.pageSize) >= this.filter.total;
    },
    disabled () {
      return this.page > this.total;
    }
  },  
  data(){
    return {
      loading: false,
			filter: {
				id: '',
        content: '',
				pageNumber: 0,
				pageSize: 10,
        total: 1
			},
      mode: '',
      page: 1,
      total: 2,
      items: [],
      busy: false,
      descActive: 0,
      menu: undefined,
    }
  },
  async mounted() {
    const res = await api.getKnowledgeList();
    this.menu = res.data;
  },
  methods: {   
    onClose() {
      this.$emit('close');
    },
    async onLoadMore() {
      let res;
      if (this.loading) { return false; }
      // if (this.filter.id && this.filter.id !== '' || this.filter.content === '') { return false; }

      // console.log('看', this.filter, this.filter.pageNumber, this.filter.total);
      if ((this.filter.pageNumber * this.filter.pageSize) > this.filter.total) { return false;}
      this.filter.pageNumber++;
      this.loading = true;
      if (this.mode === 'search') {
        res = await api.searchKnowledge(this.filter);
      } else {
        res = await api.getKnowledge(this.filter);
      }
      this.loading = false;
      this.filter.total = res.total;
      this.items = this.items.concat(res.data);
      
    },
    onToggle(v) {
      this.descActive = v ? v : 0;
    },
    async onMenuSelect(data) {
      this.mode = 'menu';
      this.filter.id = data;
      this.filter.pageNumber = 0;
      this.items = [];
      this.onLoadMore();
      // const res = await api.getKnowledge(this.filter);
      // this.items = this.items.concat(res.data);
    },
    async onSearch() {
      this.mode = 'search';
      this.filter.id = '';
      this.filter.pageNumber = 0;
      this.items = [];
      this.onLoadMore();
    },
    dateFormat(v) {
      return dayjs(v).format('YYYY-MM-DD');
    }
  }
}
</script>

<style lang="less">
.knowledge {
  .el-drawer__header {
    padding: 25px 25px 20px;
  }
  .el-drawer__body {
    padding: 0 25px;
    color: #333;
  }
  .el-menu {
    height: 100%;

    .el-menu-item {
      overflow: hidden;
      text-overflow: ellipsis;      
    }
  }
  .box {
    margin-bottom: 30px;
    display: flex;
    button {
      margin-left: 20px;
    }
  }
  .hot-key {
    margin-bottom: 30px;
    text-align: center;
  }
  .km {
    height: calc(100vh - 180px);
  }
  .key-item {
    margin-bottom: 30px;
    padding: 20px 30px;
    border: solid 1px #e6e6e6;

    &.hide {
      .desc {
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;        
      }
      .expand, .cate, .source {
        display: none;
      }
      .collapse {
        display: block;
      }
    }
    .expand {
      display: block;
    }      
    .collapse {
      display: none;
    }    

    .title {
      margin-bottom: 10px;
      font-size: 22px;
    }
    .desc {
      margin-bottom: 20px;
    }
    .cate {
      margin-bottom: 10px;
    }
    .source {
      margin-bottom: 10px;
    }
    .extra {
      display: flex;
      justify-content: space-between;

    }
  }
  .infinite-list {
    height: calc( 100vh - 180px);
    overflow: auto;
  }
}
</style>
